import { AssignList } from '../../../../../../ui-components/lib/lookup-field/lookup-field-item';
import { DelegationTaskScope } from '../delegation.model';

export const DELEGATION_USER_LOOKUP_ASSIGN_LIST: AssignList = {
  label: 'label',
  value: 'value',
  icon: 'image',
  extraLabels: [
    {
      key: 'department_name',
      type: 'text',
      label: 'delegation_form_screen_department_label',
    },
    {
      key: 'job_title',
      type: 'text',
      label: 'delegation_form_screen_job_title_label',
    },
  ],
};

export const DELEGATION_WORKFLOW_LOOKUP_ASSIGN_LIST: AssignList = {
  label: 'name',
  value: 'id',
  icon: 'icon',
  extraLabels: [
    {
      key: 'description',
      label: 'delegation_form_screen_description_label',
    },
    {
      key: 'category.name',
      label: 'delegation_form_screen_category_label',
    },
  ],
};

export const DELEGATION_TASK_SCOPE_OPTIONS = [
  // {
  //   value: DelegationTaskScope.ALL,
  //   label: 'delegation_form_screen_task_scope_all_label',
  //   description: 'delegation_form_screen_task_scope_all_description',
  // },
  {
    value: DelegationTaskScope.DIRECT,
    label: 'delegation_form_screen_task_scope_direct_label',
    description: 'delegation_form_screen_task_scope_direct_description',
  },
] as const;
